// helpers.ts - funções utilitárias para o plugin VueTestId

export function isEmptyString(str: string): boolean {
  return typeof str === "string" && str.trim() === "";
}

export function hasTransition(str: string): boolean {
  return /transition/i.test(str);
}

export function toKebabCase(str: string): string {
  if (!str) return "";
  return str
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();
}

export function isDefaultSkipping(str: string): boolean {
  const defaultSkippingInstanceNames = [
    /^App$/i,
    /^default$/i,
    /main$/i,
    /\.page/i,
  ];
  return defaultSkippingInstanceNames.some((regex) => regex.test(str));
}

export function findValidParentName(vm: any): string | null {
  let parent = vm && vm.$parent;
  let levels = 0;
  while (parent && levels < 3) {
    const name = parent.$options?.name || parent.$options?.__name;
    if (name && !/^vtu-?root$/i.test(name) && !isDefaultSkipping(name)) {
      return name;
    }
    parent = parent.$parent;
    levels++;
  }
  return null;
}

export function mergeTestIdKey(parentName: string, childName: string): string {
  if (!parentName || !childName) return "";
  const parentKeys = toKebabCase(parentName).split("-");
  const childKeys = toKebabCase(childName).split("-");
  let i = 0;
  while (
    i < parentKeys.length &&
    i < childKeys.length &&
    parentKeys[i] === childKeys[i]
  ) {
    i++;
  }
  const prefix = parentKeys.slice(0, i);
  const parentSuffix = parentKeys.slice(i);
  const childSuffix = childKeys.slice(i);
  return [...prefix, ...parentSuffix, ...childSuffix].filter(Boolean).join("-");
}
